export default __webpack_public_path__ + "static/media/flutter.2597aa88.jpg";